import React, { FunctionComponent } from 'react';
import { Card, Modal, Table } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import { ModalProps } from '../../types/ModalProps';
import dateToString from '../../services/misc/dateToString';
import CopyContentComponent from './CopyContent.component';

export const SignerDetailModalComponent: FunctionComponent<ModalProps> = ({ showModal = false, onClose, data }) => {
    const { t } = useTranslation();

    const matrix = [
        // key of translation , key of value (currently app uses the same wording, but you can change it in the ACL)
        ['firstName', 'firstName'],
        ['lastName', 'lastName'],
        ['birthdate', 'birthdate'],
        ['email', 'email'],
        ['mobilePhoneNumber', 'mobilePhoneNumber'],
        ['address', 'streetName', 'houseNumber'],
        ['addressAddition', 'addressAddition'],
        ['postalCode', 'postalCode'],
        ['city', 'city'],
        ['consentGivenAt', 'consentGivenAt'],
    ];

    function createSignerValue(values: Array<string>): React.ReactElement {
        const signer = data;
        if (signer) {
            const output = values.map((key) => {
                switch (key) {
                    case 'birthdate':
                        const date = dateToString(signer[key], 'dateShort') || '..';
                        return <CopyContentComponent>{date}</CopyContentComponent>;
                    default:
                        const formatted = signer[key] + ' ';
                        return <CopyContentComponent>{formatted}</CopyContentComponent>;
                }
            });
            return <>{output}</>;
        }
        return <></>;
    }

    return (
        <Modal open={showModal} size={'large'} closeOnEscape={true} closeOnTriggerBlur={true} onClose={onClose}>
            <Modal.Header>{t('lead.detail.box.KYC.signer.details')}</Modal.Header>
            <Modal.Content scrolling={true}>
                <Card.Content>
                    <Card.Description>
                        <Table celled striped columns={2}>
                            <Table.Body>
                                {matrix.map((row: Array<string>, ix) => (
                                    <Table.Row key={ix}>
                                        <Table.Cell width={4}>{t(`lead.detail.box.signer.${row[0]}`)}</Table.Cell>
                                        <Table.Cell singleLine>{createSignerValue(row.splice(1))}</Table.Cell>
                                    </Table.Row>
                                ))}
                            </Table.Body>
                        </Table>
                    </Card.Description>
                </Card.Content>
            </Modal.Content>
        </Modal>
    );
};
